import { handleActions } from 'redux-actions'

import { setOpenAlertsCounts } from 'src/store/modules/openAlerts/actionCreators'

const initialState = {
  // Open alerts count per patient uuid, shared by every alert count badge
  counts: {}
}

export default handleActions(
  {
    // Merged, not replaced, because badges on different screens track
    // different patients at the same time
    [setOpenAlertsCounts](state, { payload: counts = {} }) {
      return {
        ...state,
        counts: {
          ...state.counts,
          ...counts
        }
      }
    }
  },
  initialState
)
